import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgProgress, NgProgressRef } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { ConfirmActionComponent } from 'src/app/components/dialog/confirm/confirm-action/confirm-action.component';
import { FileData, ReferenceParams, Res } from 'src/app/models';
import { ApiOrganizationsService, DatetimeService, DialogModalService, FilesService, NotificationService, PermissionService, ValidatorsService } from 'src/app/services';
import { ApiBasicService } from 'src/app/services/api-basic.service';
import { FileValidator } from './file-edit.validators';

@Component({
  selector: 'app-file-edit',
  templateUrl: './file-edit.component.html',
  styleUrls: ['./file-edit.component.css']
})
export class FileEditComponent implements OnInit {

  subscriptions: Subscription = new Subscription();
  progressRef: NgProgressRef;
  loading: boolean;
  errorMessages: any;
  fileId: string;
  fileData: FileData = null;
  fileLink: string;
  org_id: string;
  categories: any[] = [];
  multiple: false;
  valid_to: any;
  currentDate = new Date();
  valueDate = this.datetimeService.convertDateForDatepicker(this.currentDate.setDate(this.currentDate.getDate() + 2));

  form: UntypedFormGroup = this.fb.group({
    id: [null],
    name: [null, this.fileValidator.name],
    valid_to: [null],
    category_id: [null],
    org_id: [null],
    extension: [null],
    file: [null]
  });

  constructor(
    public ngProgress: NgProgress,
    private fb: UntypedFormBuilder,
    public activeModal: NgbActiveModal,
    private notification: NotificationService,
    private apiBasic: ApiBasicService,
    private apiFileService: FilesService,
    private currentRoute: ActivatedRoute,
    public datetimeService: DatetimeService,
    private apiOrganizations: ApiOrganizationsService,
    private validatorService: ValidatorsService,
    private dialogModal: DialogModalService,
    private fileValidator: FileValidator,
    public permissionAccess: PermissionService
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');
    this.errorMessages = this.fileValidator.errorMessages;
    this.fileId = this.currentRoute.snapshot.paramMap.get('id');
    this.org_id = this.apiOrganizations.currentOrganization.id;
    this.getFileInfo(this.fileId)
    this.getCategories();
  }

  /**
   * 
   * @param searchValue - значение для поиска вводимое вручную
   * @param currentElemId - текущее значение из справочника передаваемое при его выборе из списка
   */
  getCategories(): void {

    let params: ReferenceParams = {
      ref_name: 'files_categories',
      filter: {
        name: '',
        parent_id: ''
      }
    }

    this.subscriptions.add(
      this.apiBasic.getReferences(params, params.ref_name).subscribe((response: Res) => {
        console.log("CATEGORIES: ", response);

        if (response != null) {

          this.categories = response.result;
        }

        this.loading = false;
      },
        error => {
          this.loading = false;
        })
    );
  }

  /**
   * 
   * @param file
   */
  getFileInfo(id: string): void {

    this.fileData = null;
    this.loading = true;

    this.progressRef.start();

    this.subscriptions.add(
      this.apiFileService.getFileInfo(id).subscribe(response => {
        console.log("[RESPONSE] getFileInfo: ", response);

        if (response != null) {
         
        //  response.result.name = response.result.name.replace(/\.[^/.]+$/, "");
         response.result.name = response.result.name.split('.').slice(0, -1).join('.');

          this.fileData = response.result;

          this.getImageContent(id);

          this.setDataInForm(response.result);

          if (this.fileData.link) {

            this.fileData.link = this.fileData.link.substring(26);
          }
        }

        this.loading = false;
        this.progressRef.complete();
      })
    );
  }

  /**
   * 
   * @param fileData 
   * @returns 
   */
  setDataInForm(fileData: FileData): void {

    if (!fileData) return;

    this.valid_to = fileData.meta.valid_to;

    this.form.patchValue({
      id: fileData.file_id,
      org_id: this.org_id,
      name: fileData.name,
      valid_to: fileData.meta.valid_to,
      extension: fileData.extension,
      category_id: fileData.category_id
    });
  }


  /**
    * 
    * @param fileName string
    * @returns string
    */
  checkIconExt(fileName: string): string {

    return this.apiFileService.checkIconExt(fileName);
  }


  /**
   * 
   * @param index 
   * @param image 
   */
  getImageContent(file_id: any): void {

    this.fileLink = null

    this.subscriptions.add(

      this.apiFileService.getImageContent(file_id).subscribe((response: any) => {

        if (response != null) {

          this.fileLink = response.result;

        }
      })
    );
  }

  /**
   * 
   * @param fieldName 
   * @param value 
   */
  eventFnDPVC(fieldName: string, value: any): void {

    this.form.controls[fieldName].setValue(value);

  }


  /**
   * 
   * @param size 
   * @returns 
   */
  convertationToMb(size: number): string {

    let convertData: number;
    let dataType: string = "kb";

    convertData = size / 1024;

    if (convertData > 1024) {
      convertData = convertData / 1024;
      dataType = "mb"
    }

    return convertData.toFixed(2) + " " + dataType;
  }

  /**
   * 
   * @param files FileList
   */
  selectFile(files: FileList): void {


    if (files[0].name.length > 50) {

      this.dialogModal.open('Длина имени файла превышает 50 символов и при загрузке будет обрезана! Продолжить загрузку?', ConfirmActionComponent).then(

        (result) => {

          if (result) {

            this.form.get('name').setValue(this.getModifyName(files[0].name));

            this.form.get('extension').setValue(this.apiFileService.checkIconExt(files[0].name));

            this.notification.show('success', 'Файл успешно загружен!');

          }
        },
        () => { console.log('Rejected!'); }
      );

    }else{

      this.form.get('name').setValue(files[0].name.split('.').slice(0, -1).join('.'));

      this.form.get('extension').setValue(this.apiFileService.checkIconExt(files[0].name));

      this.notification.show('success', 'Файл успешно загружен!');
    }

    this.form.get('file').setValue(files[0])

  }

  /**
   * 
   * @param fileName 
   * @returns 
   */
  getModifyName(fileName: string): string {

    return String(fileName.substring(0, 50));

  }

  /**
   * 
   */
  onUpdate() {

    this.progressRef.start();

    const formData = new FormData();

    formData.append('id', this.form.get('id').value);
    formData.append('org_id', this.form.get('org_id').value);
    formData.append('name', this.form.get('name').value + '.' + this.form.get('extension').value);

    if (this.form.get('valid_to').value) {

      formData.append('valid_to', this.form.get('valid_to').value);
    }

    if (this.form.get('category_id').value) {

      formData.append('category_id', this.form.get('category_id').value);
    }

    if (this.form.get('file').value) {

      formData.append('file', this.form.get('file').value);
    }


    this.subscriptions.add(
      this.apiFileService.updateFile(formData).subscribe((response: Res) => {
        console.log('[RESPONSE] updateUserInfo: ', response);

        if (response != null) {

          this.notification.show('success', 'Данные успешно сохранены!');
          this.getFileInfo(response.result.id)
        }

        this.progressRef.complete();
      },
        error => {
          this.progressRef.complete();
        })
    );
  }

  /**
 * 
 * @param field 
 * @param type 
 */
  validation(field: string, type: string): boolean {

    return this.validatorService.validation(this.form.get(field), type);
  }
}
